import { useEffect } from "react";

/**
 * 防止页面滚动穿透的 Hook
 *
 * 主要功能：
 * - 监听 touchmove 事件
 * - 当弹窗遮罩层存在时，阻止事件冒泡以防止底层页面滚动
 * - 防止弹窗打开时背景页面仍然可以滚动的问题
 *
 * 使用场景：
 * - 模态弹窗/对话框
 * - 底部弹层
 * - 任何需要阻止背景页面滚动的场景
 *
 * 注意：
 * - 目前边缘拖动场景下可能仍存在偶发的滚动穿透问题
 * - 适用于移动端触摸设备
 */
const useScrollPassIssue = (className = "xpm-center-popup-mask") => {
  useEffect(() => {
    const eFun = (e) => {
      const mask = document.getElementsByClassName(className)?.[0];
      if (mask && e.target) {
        // TODO 边缘拖动还是偶尔能滚动穿透
        if (mask.contains(e.target) || mask == e.target) {
          console.log("touchmove:  阻止弹窗滚动穿透");
          e.preventDefault();
        }
      }
    };
    document.addEventListener("touchmove", eFun, { passive: false });
    return () => {
      document.removeEventListener("touchmove", eFun);
    };
  }, [className]);
};

export default useScrollPassIssue;
